import { useQuery } from 'react-query'
import { useMainContext } from '../../contexts/main'
import { putApi } from '../fetch-api/put'

export const useBankCallbackQuery = ({ trackId = '' }) => {
	const {
		profile: { token },
	} = useMainContext()


	return useQuery(
		'fetch-bank-callback',
		() => putApi(undefined, token, `banking/callback/${trackId}`),
		{
			enabled: !!token,
			select: (res) => res.data?.data?.bankResult || {},
			refetchOnWindowFocus: false,
		}
	)
}
